import { useEffect, useState, useTransition } from "react";
import { AdItemType } from "../../../../biz/data/redux/organizationReducer";
import { Padder } from "../SimpleElements";
import { useAdsSettings, useAdsUISettings } from "./useAds";
import { useOrganization } from "../../../../biz/hooks/entities/useOrganization";
import { useTranslation } from "react-i18next";

export const AdPreview = ({ ad, imageSrc }: { ad: AdItemType, imageSrc: string | ArrayBuffer | null }) => {


    const currentOrg = useOrganization()?.currentOrganization;
    // const orgName = currentOrg?.customerContactName ?? currentOrg?.name ?? "";
    const orgName = currentOrg?.name ?? "";

    const adModel = useAdsUISettings().adsUISettings?.editModels?.[ad?.id] ?? ad;

    if (ad?.type === "discovery_featured") {
        return (<AdPreviewDiscoveryFeatured ad={adModel} imageSrc={imageSrc} imageUrl={ad?.imageUrl} orgName={orgName} />)
    } /*else if (ad?.type === "discovery_featured_secondaryxxx") {
        return (<AdPreviewDiscoveryFeaturedSecondary ad={adModel} imageSrc={imageSrc} imageUrl={ad?.imageUrl} orgName={orgName} />)
    }*/ else if (ad?.type === "calendar_list" || ad?.type === "forum_feed" || ad?.type === "plantsearch" || ad?.type === "discovery_featured_secondary") {
        return (<AdPreviewCalendarList ad={adModel} imageSrc={imageSrc} imageUrl={ad?.imageUrl} orgName={orgName} />)
    } else if (ad?.type === "monthly_article") {
        return (<AdPreviewMonthlyArticle ad={adModel} imageSrc={imageSrc} imageUrl={ad?.imageUrl} orgName={orgName} />)
    } else if (ad?.type === "offer") {
        return (<AdPreviewOffer ad={adModel} imageSrc={imageSrc} imageUrl={ad?.imageUrl} orgName={orgName} />)
    } else if (ad?.type === "plantdetail_main") {
        return (<AdPreviewPlantDetailMain ad={adModel} imageSrc={imageSrc} imageUrl={ad?.imageUrl} orgName={orgName} />)
    } else if (ad?.type === "plantdetail_main_web") {
        return (<AdPreviewPlantDetailMainWeb ad={adModel} imageSrc={imageSrc} imageUrl={ad?.imageUrl} orgName={orgName} />)
    }



    return (<div>
        {ad?.type}
    </div>)
}

// *******************************************************************************
// ************************************* Ads *************************************
// *******************************************************************************

const AdPreviewDiscoveryFeatured = ({ ad, imageSrc, imageUrl, orgName }: { ad: AdItemType, imageSrc: string | ArrayBuffer | null, imageUrl: string, orgName: string, }) => {
    const cssBg = useAdPreview({
        imageSrc: imageSrc,
        imageUrl: imageUrl,
        sys_datemodified_utc_epoch: ad?.sys_datemodified_utc_epoch,
    });
    const def = useAdsSettings().find(t => t.type === ad?.type);
    const { t } = useTranslation();
    return (
        <>
            <div className={"type-" + ad?.type}
                style={{
                    backgroundImage: cssBg.backgroundImageWithGradient,
                    backgroundPosition: 'center',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    //opacity: processing ? 0.5 : 1
                }}
            >

                <div className="press">
                    <CircleWithArrow size="32px" />
                </div>
                <div className="annons-header">{t("advert")} / {orgName}</div>
                <Padder heightPx={8} />
                <div className="rubrik">{ad?.title01 || def?.title01Label}</div>
                <Padder heightPx={8} />
                <div className={!ad?.hasOfferDetails ? "beskrivning-long" : "beskrivning"}>{ad?.title02 || def?.title02Label}</div>
                <Padder heightPx={8} />

                {!!ad?.hasOfferDetails && (
                    <div className="underrubriker">
                        <div className="underrubrik-1">{ad?.title03 || def?.title03Label}</div>
                        <div className="underrubrik-2">{ad?.title04 || def?.title04Label}</div>
                    </div>
                )}

            </div>
        </>
    )
}


const AdPreviewDiscoveryFeaturedSecondary = ({ ad, imageSrc, imageUrl, orgName }: { ad: AdItemType, imageSrc: string | ArrayBuffer | null, imageUrl: string, orgName: string }) => {
    const cssBg = useAdPreview({
        imageSrc: imageSrc,
        imageUrl: imageUrl,
        sys_datemodified_utc_epoch: ad?.sys_datemodified_utc_epoch,
        gradientDefinition: "linear-gradient(180deg, rgba(38, 27, 23, 0.50) 0%, #261B17 100%)"
    })
    const def = useAdsSettings().find(t => t.type === ad?.type);
    const { t } = useTranslation();
    return (
        <>
            <div className={"type-" + ad?.type}
                style={{
                    backgroundImage: cssBg.backgroundImageWithGradient,
                    backgroundPosition: 'center',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    // opacity: processing ? 0.5 : 1
                }}
            >

                <div className="press">
                    <CircleWithArrow size="32" />
                </div>
                <div className="annons-header">{t("advert")} / {orgName}</div>
                <Padder heightPx={18} />
                <div className="rubrik">{ad?.title01 || def?.title01Label}</div>
                <Padder heightPx={8} />
                <div className={!ad?.hasOfferDetails ? "beskrivning-long" : "beskrivning"}>{ad?.title02 || def?.title02Label}</div>

                {!!ad?.hasOfferDetails && (
                    <>
                        <Padder heightPx={32} />
                        <div className="expires">{ad?.title03 || def?.title03Label}</div>
                    </>
                )}
            </div>
        </>
    )
}


const AdPreviewCalendarList = ({ ad, imageSrc, imageUrl, orgName }: { ad: AdItemType, imageSrc: string | ArrayBuffer | null, imageUrl: string, orgName: string }) => {
    const cssBg = useAdPreview({
        imageSrc: imageSrc,
        imageUrl: imageUrl,
        sys_datemodified_utc_epoch: ad?.sys_datemodified_utc_epoch,
        // gradientDefinition: "linear-gradient(180deg, rgba(38, 27, 23, 0.08) 0%, rgba(38, 27, 23, 0.40) 100%)"
        gradientDefinition: "linear-gradient(180deg, rgba(0, 0, 0, 0.0) 0%, rgba(0, 0, 0, 0.0) 0%)"
    });
    const def = useAdsSettings().find(t => t.type === ad?.type);
    const { t } = useTranslation();
    return (
        <>
            <div className={"type-" + ad?.type}>

                <div className="first-col">
                    <div className="annons-header">{t("advert")} / {orgName}</div>
                    <Padder heightPx={8} />
                    <div className="rubrik">{ad?.title01 || def?.title01Label}</div>
                    <Padder heightPx={8} />
                    <div className="beskrivning">{ad?.title02 || def?.title02Label}</div>
                    <Padder heightPx={8} />

                    {!!ad?.hasOfferDetails && (
                        <div className="underrubriker">
                            <div className="underrubrik-1">{ad?.title03 || def?.title03Label}</div>
                            <div className="underrubrik-2">{ad?.title04 || def?.title04Label}</div>
                        </div>
                    )}
                </div>

                <div className="last-col" style={{
                    backgroundImage: cssBg.backgroundImageWithGradient,
                    backgroundPosition: 'center',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    // opacity: processing ? 0.5 : 1
                }}>
                    <div className="press">
                        <CircleWithArrow size="32" />
                    </div>
                </div>

            </div>
        </>
    )
}

const AdPreviewMonthlyArticle = ({ ad, imageSrc, imageUrl, orgName }: { ad: AdItemType, imageSrc: string | ArrayBuffer | null, imageUrl: string, orgName: string }) => {
    const cssBg = useAdPreview({
        imageSrc: imageSrc,
        imageUrl: imageUrl,
        sys_datemodified_utc_epoch: ad?.sys_datemodified_utc_epoch,
        // gradientDefinition: "linear-gradient(180deg, rgba(38, 27, 23, 0.08) 0%, rgba(38, 27, 23, 0.40) 100%)"
        gradientDefinition: "linear-gradient(180deg, rgba(0, 0, 0, 0.0) 0%, rgba(0, 0, 0, 0.0) 0%)"
    });
    const def = useAdsSettings().find(t => t.type === ad?.type);
    const { t } = useTranslation();
    return (
        <>
            <div className={"type-" + ad?.type}>

                <div className="first-col">
                    <div className="annons-header">{t("advert")} / {orgName}</div>
                    <Padder heightPx={8} />
                    <div className="rubrik">{ad?.title01 || def?.title01Label}</div>
                    <Padder heightPx={8} />
                    <div className="beskrivning">{ad?.title02 || def?.title02Label}</div>
                    <Padder heightPx={8} />
                </div>

                <div className="last-col" style={{
                    backgroundImage: cssBg.backgroundImageWithGradient,
                    backgroundPosition: 'center',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    // opacity: processing ? 0.5 : 1
                }}>
                    <div className="press">
                        <CircleWithArrow size="32" />
                    </div>
                </div>

            </div>
        </>
    )
}

const AdPreviewOffer = ({ ad, imageSrc, imageUrl, orgName }: { ad: AdItemType, imageSrc: string | ArrayBuffer | null, imageUrl: string, orgName: string }) => {
    const cssBg = useAdPreview({
        imageSrc: imageSrc,
        imageUrl: imageUrl,
        sys_datemodified_utc_epoch: ad?.sys_datemodified_utc_epoch,
        // gradientDefinition: "linear-gradient(180deg, rgba(38, 27, 23, 0.08) 0%, rgba(38, 27, 23, 0.40) 100%)"
        gradientDefinition: "linear-gradient(180deg, rgba(0, 0, 0, 0.0) 0%, rgba(0, 0, 0, 0.0) 0%)"
    });
    const def = useAdsSettings().find(t => t.type === ad?.type);

    return (
        <>
            <div className={"type-" + ad?.type}>

                <div className="first-col" style={{
                    backgroundImage: cssBg.backgroundImageWithGradient,
                    backgroundPosition: 'center',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    // opacity: processing ? 0.5 : 1
                }}>
                </div>

                <div className="last-col">
                    <div className="container">
                        <div className="annons-header">{orgName}</div>
                        <Padder heightPx={8} />
                        <div className="rubrik">{ad?.title01 || def?.title01Label}</div>
                        <Padder heightPx={8} />
                        <div className="beskrivning">{ad?.title02 || def?.title02Label}</div>
                        {!!ad?.hasOfferDetails && (
                            <>
                                <Padder heightPx={8} />
                                <div className="underrubrik">{ad?.title03 || def?.title03Label}</div>
                            </>
                        )}
                    </div>
                </div>
                <div className="perf">

                </div>



            </div>
        </>
    )
}

const AdPreviewPlantDetailMain = ({ ad, imageSrc, imageUrl, orgName }: { ad: AdItemType, imageSrc: string | ArrayBuffer | null, imageUrl: string, orgName: string }) => {
    const cssBg = useAdPreview({
        imageSrc: imageSrc,
        imageUrl: imageUrl,
        sys_datemodified_utc_epoch: ad?.sys_datemodified_utc_epoch,
        // gradientDefinition: "linear-gradient(180deg, rgba(38, 27, 23, 0.08) 0%, rgba(38, 27, 23, 0.40) 100%)"
        gradientDefinition: "linear-gradient(180deg, rgba(0, 0, 0, 0.0) 0%, rgba(0, 0, 0, 0.0) 0%)"
    });
    const def = useAdsSettings().find(t => t.type === ad?.type);
    const { t } = useTranslation();
    return (
        <>
            <div className={"type-" + ad?.type}>

                <div className="first-col">
                    <div className="annons-header">{t("advert")} / {orgName}</div>
                    <Padder heightPx={8} />
                    <div className="rubrik">{ad?.title01 || def?.title01Label}</div>
                    <Padder heightPx={8} />
                    <div className="beskrivning">{ad?.title02 || def?.title02Label}</div>
                    <Padder heightPx={8} />
                </div>

                <div className="last-col" style={{
                    backgroundImage: cssBg.backgroundImageWithGradient,
                    backgroundPosition: 'center',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    // opacity: processing ? 0.5 : 1
                }}>
                    <div className="press">
                        <CircleWithArrow size="32" />
                    </div>
                </div>

            </div>
        </>
    )
}

const AdPreviewPlantDetailMainWeb = ({ ad, imageSrc, imageUrl, orgName }: { ad: AdItemType, imageSrc: string | ArrayBuffer | null, imageUrl: string, orgName: string }) => {
    const cssBg = useAdPreview({
        imageSrc: imageSrc,
        imageUrl: imageUrl,
        sys_datemodified_utc_epoch: ad?.sys_datemodified_utc_epoch,
        // gradientDefinition: "linear-gradient(180deg, rgba(38, 27, 23, 0.08) 0%, rgba(38, 27, 23, 0.40) 100%)"
        gradientDefinition: "linear-gradient(180deg, rgba(0, 0, 0, 0.0) 0%, rgba(0, 0, 0, 0.0) 0%)"
    });
    const def = useAdsSettings().find(t => t.type === ad?.type);
    const { t } = useTranslation();

    return (
        <>
            <div className={"type-" + ad?.type}>

                <div className="first-col">
                    <div className="annons-header">{t("advert")} / {orgName}</div>
                    <Padder heightPx={8} />
                    <div className="rubrik">{ad?.title01 || def?.title01Label}</div>
                    <Padder heightPx={8} />
                    <div className="beskrivning">{ad?.title02 || def?.title02Label}</div>
                    <Padder heightPx={8} />
                </div>

                <div className="last-col" style={{
                    backgroundImage: cssBg.backgroundImageWithGradient,
                    backgroundPosition: 'center',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    // opacity: processing ? 0.5 : 1
                }}>
                    <div className="press">
                        <CircleWithArrow size="32" />
                    </div>
                </div>
            </div>
        </>
    )
}

// *******************************************************************************
// *********************************** Helpers ***********************************
// *******************************************************************************
export const useAdPreview = (options: {
    imageSrc: string | ArrayBuffer | null,
    imageUrl: string,
    sys_datemodified_utc_epoch: number,
    fallBackUrl?: string,
    gradientDefinition?: string
}
) => {

    const imageSrc = options?.imageSrc;
    const imageUrl = !!options?.imageUrl ? options?.imageUrl : !!options?.fallBackUrl ? options?.fallBackUrl : undefined;
    const sys_datemodified_utc_epoch = options?.sys_datemodified_utc_epoch;

    const gradString = options?.gradientDefinition ?? "linear-gradient(180deg, rgba(14, 11, 6, 0.20) 0%, rgba(14, 11, 6, 0.80) 100%)";

    const imageSrcString = "url(" + (imageSrc as any) + ")";
    const [backgroundImageWithGradient, setBackgroundImageWithGradient] = useState<string>(gradString + "," + imageSrcString);
    const [backgroundImage, setBackground] = useState<string>(imageSrcString);

    useEffect(() => {
        if (imageSrc) {
            setBackgroundImageWithGradient(gradString + "," + imageSrcString);
            setBackground(imageSrcString);
        } else if (!!imageUrl) {
            const imageUrl_versioning = imageUrl + "?v=" + sys_datemodified_utc_epoch;
            const _imageSrcString = "url(" + imageUrl_versioning + ")";
            setBackgroundImageWithGradient(gradString + "," + _imageSrcString)
            setBackground(imageSrcString);
        } else {
            setBackgroundImageWithGradient("");
            setBackground("");
        }
    }, [, imageSrc, imageUrl]);

    return {
        backgroundImageWithGradient: backgroundImageWithGradient,
        backgroundImage: backgroundImage,
    }

}

const CircleWithArrow = ({ size }: { size?: string }) => {

    return (
        <svg width={size ?? "40"} height={size ?? "40"} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z" fill="#F7D5C9" />
            <path d="M22.75 16.5625L17.25 21.8125C16.9375 22.0938 16.4688 22.0938 16.1875 21.7813C15.9062 21.4688 15.9062 21 16.2188 20.7188L20.375 16.75H9.75C9.3125 16.75 9 16.4375 9 16C9 15.5938 9.3125 15.25 9.75 15.25H20.375L16.2188 11.3125C15.9062 11.0313 15.9062 10.5313 16.1875 10.25C16.4688 9.9375 16.9688 9.9375 17.25 10.2188L22.75 15.4688C22.9062 15.625 23 15.8125 23 16C23 16.2188 22.9062 16.4063 22.75 16.5625Z" fill="#8F4838" />
        </svg>

    )

    return (
        <svg width={size ?? "40"} height={size ?? "40"} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z" fill="url(#paint0_linear_3817_8173)" />
            <path d="M24.1147 11.3212C23.9518 11.0803 23.7074 11 23.463 11C23.3001 11 23.1372 11.0802 22.9742 11.1605C22.6484 11.4014 22.5669 11.9634 22.8113 12.2845L27.5177 18.7073L11.8146 18.7073C11.4073 18.7073 11 19.0284 11 19.5102C11 19.9919 11.3258 20.313 11.8146 20.313L27.5178 20.313L22.8113 26.736C22.5669 27.0571 22.6484 27.6191 22.9742 27.86C23.3001 28.1008 23.8703 28.0205 24.1147 27.6993L29.8167 19.9919C30.0611 19.6708 30.0611 19.3497 29.8167 19.0286L24.1147 11.3212Z" fill="#3E4B43" />
            <defs>
                <linearGradient id="paint0_linear_3817_8173" x1="-2.3221e-07" y1="40" x2="40" y2="-2.3221e-07" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FEAF9E" />
                    <stop offset="1" stopColor="#FFC7AE" />
                </linearGradient>
            </defs>
        </svg>
    )
}